export default __webpack_public_path__ + "static/favicon-14f8e513b65afd9a6161b278b5fde4d8.png";